import { render, staticRenderFns } from "./TefTransactionsHistory.vue?vue&type=template&id=ac5165ba&"
import script from "./TefTransactionsHistory.vue?vue&type=script&lang=js&"
export * from "./TefTransactionsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports